// extracted by mini-css-extract-plugin
module.exports = {"figure":"AxiosVisualsStreamCap__figure--_SZ4j"};